import { Stack, Table, TableBody, TableContainer } from '@mui/material';
import { TableFlexOverflowContainer } from '@/components';
import { TransactionsTableHead } from './TransactionsTableHead';
import { TransactionsOptionHead } from './TransactionsOptionHead';
import { TransactionsList } from './TransactionsList';

export type TableProps = {
  value: number;
  index: number;
};

export const TransactionsTable = ({ value, index }: TableProps) => {
  return (
    <Stack display={value !== index ? 'none' : 'block'}>
      <TransactionsOptionHead />
      <TableFlexOverflowContainer>
        <TableContainer>
          <Table stickyHeader>
            <TransactionsTableHead />
            <TableBody>
              <TransactionsList />
            </TableBody>
          </Table>
        </TableContainer>

        {/* <UsersPagination /> */}
      </TableFlexOverflowContainer>
    </Stack>
  );
};
